module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-whyus-photo-02.jpg?h=84a09d78b3fabfc558cf15c6a0796c51";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-whyus-photo-02.jpg
// module id = 2101
// module chunks = 12 15